/** When setting global window variables to check against in an optimize A/B test,
 * use the windowKey below as the window property. Then set your variantKey with its
 * value(s) and copy it in the array below. The ABTestManager will update, when the
 * Optimize script tries to set the property, the relevant field of ReactQuery.
 */
const config = () => ({
  windowKey: 'blick_abTest' as const,
  variantKeys: [],
})

export type configType = ReturnType<typeof config>
export default config
